import jquery from 'jquery';
import URL from '@/tools/url';
import { setupCsrfToken } from '@/ajax/shop/helpers/setupCsrfToken';

/**
 * Построение корректного URL для отправки отзывов
 * @param {String} productUrl - URL товара
 * @returns {String} - URL для отправки отзывов
 */
function buildReviewsUrl(productUrl) {
  try {
    const url = new URL(productUrl, window.location.origin);

    return url.origin + url.pathname + '/reviews.json';
  } catch (catchError) {
    // Фоллбек для случаев, когда URL некорректный
    // Убираем GET-параметры вручную
    const cleanUrl = productUrl.split('?')[0].split('#')[0];

    return cleanUrl + '/reviews.json';
  }
}

/**
 * @description
 * Отправка отзыва к товару
 *
 * @param {Object} review - объект с отзывом. ОБЯЗАТЕЛЬНО
 * @param {String} review.author - автор отзыва. ОБЯЗАТЕЛЬНО
 * @param {String} review.email - e-mail посетителя. ОБЯЗАТЕЛЬНО
 * @param {String} review.content - тело отзыва.ОБЯЗАТЕЛЬНО
 * @param {String} review.captcha_solution - капча. ОБЯЗАТЕЛЬНО
 * @param {String} review.captcha_challenge - капча. ОБЯЗАТЕЛЬНО
 * @param {String} productUrl - url товара, к которому хотим оставить отзыв
 * @param {Object} image_attributes][image - картинка
 *
 * @return {Promise} - поток выполнения задачи
 */
export default function(review, productUrl) {
  setupCsrfToken();

  const _result = jquery.Deferred();
  const _lang = URL.getKeyValue('lang') || '';

  review.append('lang', _lang);

  // Правильно формируем URL для отправки отзыва
  const _reviewsUrl = buildReviewsUrl(productUrl);

  jquery.ajax({
    url: _reviewsUrl,
    data: review,
    type: 'POST',
    processData: false,
    contentType: false,
    success: function(response) {
      if (response.status == 'ok') {
        _result.resolve({ status: 'ok' });
      } else {
        _result.reject(response);
      }
    }
  });

  return _result.promise();
}
